import React from 'react';
import { Box, Grid, Typography, Paper } from '@mui/material';
import { styled } from '@mui/material/styles';
import SurrogateAvatar from './common/SurrogateAvatar.tsx';
import GradientText from './common/GradientText.tsx';

const Container = styled(Box)(({ theme }) => ({
  padding: theme.spacing(4),
  maxWidth: '1200px',
  margin: '0 auto',
}));

const Section = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  marginBottom: theme.spacing(4),
  background: 'rgba(26, 26, 46, 0.6)',
  backdropFilter: 'blur(10px)',
  borderRadius: theme.spacing(2),
  border: '1px solid rgba(138, 43, 226, 0.2)',
}));

const AvatarTest: React.FC = () => {
  return (
    <Container>
      <GradientText variant="h4" gradient="primary" sx={{ mb: 4, textAlign: 'center' }}>
        Surrogate Avatar Test
      </GradientText>

      <Section>
        <Typography variant="h6" sx={{ mb: 2, color: '#fff' }}>
          PNG Avatars with Names
        </Typography>
        <Grid container spacing={3}>
          <Grid item>
            <SurrogateAvatar name="Alpha" role="Assistant" status="active" showName={true} />
          </Grid>
          <Grid item>
            <SurrogateAvatar name="Gamma" role="Developer" status="active" showName={true} />
          </Grid>
        </Grid>
      </Section>

      <Section>
        <Typography variant="h6" sx={{ mb: 2, color: '#fff' }}>
          PNG Avatars without Names
        </Typography>
        <Grid container spacing={3}>
          <Grid item>
            <SurrogateAvatar name="Alpha" status="active" showName={false} />
          </Grid>
          <Grid item>
            <SurrogateAvatar name="Gamma" status="idle" showName={false} />
          </Grid>
        </Grid>
      </Section>

      <Section>
        <Typography variant="h6" sx={{ mb: 2, color: '#fff' }}>
          SVG Avatars
        </Typography>
        <Grid container spacing={3}>
          <Grid item>
            <SurrogateAvatar name="Beta" role="Researcher" image="Beta" status="active" showName={true} />
          </Grid>
          <Grid item>
            <SurrogateAvatar name="Delta" role="Strategist" image="Delta" status="busy" showName={true} />
          </Grid>
        </Grid>
      </Section>

      <Section>
        <Typography variant="h6" sx={{ mb: 2, color: '#fff' }}>
          Different Sizes
        </Typography>
        <Grid container spacing={3} alignItems="center">
          <Grid item>
            <SurrogateAvatar name="Alpha" size="small" status="active" showName={true} />
          </Grid>
          <Grid item>
            <SurrogateAvatar name="Alpha" size="medium" status="active" showName={true} />
          </Grid>
          <Grid item>
            <SurrogateAvatar name="Alpha" size="large" status="active" showName={true} />
          </Grid>
        </Grid>
      </Section>
    </Container>
  );
};

export default AvatarTest; 